import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Select, { components } from 'react-select';
import { customStyles } from './dropdownStyle.js';
import FormField, { FormFieldPropTypes, FormFieldInputPropTypes } from '../FormField/index.js';
import { onlyWarnInDevelopmentMode, warnOnFieldProps, warnOfDeprecation } from '../utils/propWarnings.js';

var _excluded = ["autoFocus", "changed", "className", "classNamePrefix", "components", "contrastColor", "disabled", "formatGroupLabel", "formatOptionLabel", "formFieldClassName", "fieldProps", "group", "input", "insideOfModal", "isDisabled", "isMulti", "isSearchable", "label", "menuPlacement", "meta", "noOptionsMessage", "options", "placeholder", "required", "styles", "themeColor"];
var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement("span", {
    className: cx('icon-dropdown-indicator')
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-chevron-down"
  })));
};
var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Dropdown, _React$Component);
  function Dropdown() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.rSelecRef = null;
    return _this;
  }
  var _proto = Dropdown.prototype;
  _proto.render = function render() {
    var _valueObject,
      _valueObject$options,
      _this2 = this;
    var _this$props = this.props,
      autoFocus = _this$props.autoFocus,
      changed = _this$props.changed,
      className = _this$props.className,
      classNamePrefix = _this$props.classNamePrefix,
      components = _this$props.components,
      contrastColor = _this$props.contrastColor,
      disabled = _this$props.disabled,
      formatGroupLabel = _this$props.formatGroupLabel,
      formatOptionLabel = _this$props.formatOptionLabel,
      formFieldClassName = _this$props.formFieldClassName,
      fieldProps = _this$props.fieldProps,
      group = _this$props.group,
      input = _this$props.input,
      insideOfModal = _this$props.insideOfModal,
      isDisabled = _this$props.isDisabled,
      isMulti = _this$props.isMulti,
      isSearchable = _this$props.isSearchable,
      label = _this$props.label,
      menuPlacement = _this$props.menuPlacement,
      meta = _this$props.meta,
      noOptionsMessage = _this$props.noOptionsMessage,
      options = _this$props.options,
      placeholder = _this$props.placeholder,
      required = _this$props.required,
      styles = _this$props.styles,
      themeColor = _this$props.themeColor,
      props = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var valueObject;
    if (insideOfModal) {
      props.menuPortalTarget = document.querySelector('.ReactModal__Overlay--after-open');
    }
    if (group) {
      valueObject = options === null || options === void 0 ? void 0 : options.find(function (option) {
        var _option$options;
        return option === null || option === void 0 ? void 0 : (_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.find(function (element) {
          return element.value === input.value;
        });
      });
    }
    var formApi = Object.assign({}, !group && input, group ? {
      value: (_valueObject = valueObject) === null || _valueObject === void 0 ? void 0 : (_valueObject$options = _valueObject.options) === null || _valueObject$options === void 0 ? void 0 : _valueObject$options.find(function (element) {
        return element.value === input.value;
      })
    } : {
      value: options === null || options === void 0 ? void 0 : options.find(function (option) {
        return option.value === input.value;
      })
    });
    onlyWarnInDevelopmentMode(function () {
      return warnOnFieldProps(fieldProps);
    });
    onlyWarnInDevelopmentMode(function () {
      return warnOfDeprecation(Object.assign({}, formFieldClassName && {
        'formFieldClassName': formFieldClassName
      }));
    });
    return /*#__PURE__*/React.createElement(FormField, _extends({
      label: label,
      input: input,
      required: required,
      meta: meta,
      className: formFieldClassName
    }, fieldProps), /*#__PURE__*/React.createElement(Select, _extends({}, formApi, {
      autoFocus: autoFocus,
      className: className,
      classNamePrefix: classNamePrefix || 'react-select',
      components: Object.assign({
        DropdownIndicator: DropdownIndicator
      }, components),
      contrastColor: contrastColor,
      error: meta.error,
      formatGroupLabel: formatGroupLabel,
      formatOptionLabel: formatOptionLabel,
      isDisabled: disabled || isDisabled,
      isMulti: isMulti,
      isSearchable: isSearchable,
      menuPlacement: menuPlacement,
      noOptionsMessage: noOptionsMessage,
      onChange: function onChange(e) {
        if (changed) {
          changed(e);
        }
        if (input.onChange) {
          input.onChange(e.value);
        }
        if (input.onBlur) {
          input.onBlur(e.value);
        }
        _this2.rSelecRef.blur();
      },
      options: options,
      placeholder: placeholder || 'Select one',
      ref: function ref(item) {
        return _this2.rSelecRef = item;
      },
      styles: styles || customStyles,
      themeColor: themeColor,
      touched: meta.touched
    }, props)));
  };
  return Dropdown;
}(React.Component);
Dropdown.defaultProps = {
  changed: null,
  contrastColor: '#FFF',
  isSearchable: false,
  menuPlacement: 'auto',
  options: [],
  themeColor: '#7A34FF'
};
Dropdown.propTypes = {
  autoFocus: PropTypes.bool,
  /** Passes the event just prior to firing onChange and onBlur */
  changed: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** If provided, all inner components will be given a prefixed className attribute */
  classNamePrefix: PropTypes.string,
  /** If you wish to overwrite a component, pass in an object with the appropriate namespace: https://react-select.com/components */
  components: PropTypes.object,
  fieldProps: PropTypes.shape(FormFieldPropTypes),
  formatGroupLabel: PropTypes.func,
  formatOptionLabel: PropTypes.func,
  /** This will be deprecated eventually. Instead pass className to the fieldProps */
  formFieldClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  group: PropTypes.bool,
  /** Either disabled can be set here or preferable, `isDisabled` */
  disabled: PropTypes.bool,
  options: PropTypes.array,
  input: PropTypes.shape(FormFieldInputPropTypes),
  /** If this is true, we want to target the overlay (because it's not scrollable) */
  insideOfModal: PropTypes.bool,
  /** Either disabled can be set here or via `disabled` */
  isDisabled: PropTypes.bool,
  /** Support multiple selected options */
  isMulti: PropTypes.bool,
  isSearchable: PropTypes.bool,
  label: PropTypes.node,
  meta: PropTypes.object.isRequired,
  /** Text to display when there are no options */
  noOptionsMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  placeholder: PropTypes.string,
  menuPlacement: PropTypes.oneOf(['auto', 'top', 'bottom']),
  required: PropTypes.bool,
  styles: PropTypes.object,
  contrastColor: PropTypes.string,
  themeColor: PropTypes.string
};

export { Dropdown, Dropdown as default };
//# sourceMappingURL=index.js.map
